export default "__VITE_ASSET__22b3b859__"